import * as methods from "./methods";
import "./index.scss";
const success = (msg, options) => methods.show({
  icon: 'success',
  content: msg,
  mode: 'white',
  ...options
});
const fail = (msg, options) => methods.show({
  icon: 'fail',
  content: msg,
  mode: 'white',
  ...options
});
const info = (msg, options) => methods.show({
  icon: 'info',
  content: msg,
  mode: 'white',
  ...options
});
const loading = (msg, options) => methods.show({
  icon: 'loading',
  content: msg,
  mode: 'white',
  maskClickable: false,
  duration: 0,
  ...options
});
export default {
  show: methods.show,
  /** 快捷方法: 成功消息 */
  success,
  fail,
  info,
  loading,
  clear: methods.clear,
  config: methods.config
};